import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import customFetchBase from '../expiredToken/expiredToken';
import {
  ICustomFirmwareItemData,
  IFirmwareFile,
  IFirmwareItemData
} from '../../types/firmwareVersions/firmwareVersionsInterface';

const customFetch = customFetchBase(config.baseUrlCustomers);

export const apiFirmwareVersions = createApi({
  reducerPath: 'apiLocations',
  baseQuery: customFetch,
  endpoints: (builder) => ({
    getListFirmwareVersions: builder.mutation<IFirmwareItemData[], void>({
      query: () => ({
        url: `api/Firmware/Versions`,
        method: 'GET'
      })
    }),
    getFirmwareVersionDetails: builder.mutation<IFirmwareItemData, string>({
      query: (id) => ({
        url: `api/Firmware/Version/${id}`,
        method: 'GET'
      })
    }),
    addFirmwareVersion: builder.mutation<number, {}>({
      query: (body) => ({
        url: `api/Firmware/Version`,
        method: 'POST',
        body
      })
    }),
    editFirmwareVersion: builder.mutation<
      number,
      { body: {}; versionId: number }
    >({
      query: (body) => ({
        url: `api/Firmware/Version`,
        method: 'PUT',
        body: body.body
      })
    }),
    deleteFirmwareVersions: builder.mutation<number, number[]>({
      query: (id) => ({
        url: `api/Firmware/Version?ids=${id.join(',')}`,
        method: 'DELETE'
      })
    }),
    deleteUploadedFilesFirmwareVersion: builder.mutation<number, number[]>({
      query: (id) => ({
        url: `api/Firmware/File?ids=${id.join(',')}`,
        method: 'DELETE'
      })
    }),
    getDetailsFirmwareFile: builder.mutation<{ data: IFirmwareFile }, string>({
      query: (id) => ({
        url: `api/Firmware/File/${id}`,
        method: 'GET'
      })
    }),
    getUpgradeTypes: builder.mutation<{ id: number; type: string }[], void>({
      query: () => ({
        url: `api/Firmware/UpgradeTypes`,
        method: 'GET'
      })
    }),
    postEditFile: builder.mutation<number, FormData>({
      query: (body) => ({
        url: `api/firmware/file`,
        method: 'POST',
        body
      })
    }),
    getFirmwareVersionsDetailsForFiles: builder.mutation<
      IFirmwareItemData,
      string
    >({
      query: (id) => ({
        url: `api/firmware/version/details/${id}`,
        method: 'GET'
      })
    }),
    deleteScheduleFirmwareUpdate: builder.mutation<{}, number[]>({
      query: (data) => ({
        url: `api/Firmware/Schedule?ids=${data.join(',')}`,
        method: 'DELETE',
        body: data
      })
    }),
    deleteCompletedFirmwareUpdate: builder.mutation<{}, void>({
      query: (data) => ({
        url: `api/Firmware/Schedule/Completed`,
        method: 'DELETE'
      })
    }),
    getCustomFirmwareVersions: builder.mutation<
      ICustomFirmwareItemData[],
      string
    >({
      query: (firmwareVersionId) => ({
        url: `api/Firmware/CustomVersions/ByFirmwareVersion/${firmwareVersionId}`,
        method: 'GET'
      })
    }),
    getDetailsCustomFirmwareVersion: builder.mutation<
      ICustomFirmwareItemData,
      string
    >({
      query: (firmwareVersionId) => ({
        url: `api/Firmware/CustomVersion/${firmwareVersionId}`,
        method: 'GET'
      })
    }),
    editCustomFirmwareVersion: builder.mutation<number, {}>({
      query: (body) => ({
        url: `api/Firmware/CustomVersion`,
        method: 'PUT',
        body
      })
    }),
    getFirmwareVersionDetailsForCustomFirmware: builder.mutation<
      ICustomFirmwareItemData,
      string
    >({
      query: (id) => ({
        url: `api/Firmware/CustomVersion/${id}`,
        method: 'GET'
      })
    }),
    addCustomFirmwareVersion: builder.mutation<number, {}>({
      query: (body) => ({
        url: `api/Firmware/CustomVersion`,
        method: 'POST',
        body
      })
    }),
    deleteCustomFirmwareVersion: builder.mutation<number, number[]>({
      query: (id) => ({
        url: `api/Firmware/CustomVersion?ids=${id.join(',')}`,
        method: 'DELETE'
      })
    }),
    postEditCustomUploadedFile: builder.mutation<number, FormData>({
      query: (body) => ({
        url: `api/Firmware/CustomFile`,
        method: 'POST',
        body
      })
    }),
    deleteCustomUploadedFile: builder.mutation<number, number[]>({
      query: (id) => ({
        url: `api/Firmware/CustomFile?ids=${id.join(',')}`,
        method: 'DELETE'
      })
    })
  })
});

export const {
  useGetListFirmwareVersionsMutation,
  useGetFirmwareVersionDetailsMutation,
  useAddFirmwareVersionMutation,
  useEditFirmwareVersionMutation,
  useDeleteFirmwareVersionsMutation,
  useGetDetailsFirmwareFileMutation,
  useGetUpgradeTypesMutation,
  usePostEditFileMutation,
  useDeleteUploadedFilesFirmwareVersionMutation,
  useGetFirmwareVersionsDetailsForFilesMutation,
  useDeleteScheduleFirmwareUpdateMutation,
  useDeleteCompletedFirmwareUpdateMutation,
  useGetCustomFirmwareVersionsMutation,
  useGetDetailsCustomFirmwareVersionMutation,
  useEditCustomFirmwareVersionMutation,
  useGetFirmwareVersionDetailsForCustomFirmwareMutation,
  useAddCustomFirmwareVersionMutation,
  useDeleteCustomFirmwareVersionMutation,
  usePostEditCustomUploadedFileMutation,
  useDeleteCustomUploadedFileMutation
} = apiFirmwareVersions;
